import {
  CONTEXTUAL_ENTITY_MENTION_GROUP_LABELS,
  isReferenceContextualEntityType,
  type ReferenceContextualEntityType,
} from "src/unifiedCopilot/context/entityDefinitions";
import type { ReferenceContextualEntity } from "src/unifiedCopilot/context/types";

export const RELATED_MENTION_SECTION_KEY = "related";

export const RELATED_TO_CURRENT_PAGE_LABEL = "Related to current page";

/**
 * A section of the `@` mention menu: what the current page registered
 * ambiently, or one entity type of the full catalogue.
 */
export type MentionSectionKey =
  | typeof RELATED_MENTION_SECTION_KEY
  | ReferenceContextualEntityType;

export type MentionSection = {
  key: MentionSectionKey;
  label: string;
  entities: ReferenceContextualEntity[];
};

export const isMentionSectionKey = (
  value: unknown,
): value is MentionSectionKey =>
  value === RELATED_MENTION_SECTION_KEY ||
  (typeof value === "string" && isReferenceContextualEntityType(value));

export const getMentionSectionLabel = (key: MentionSectionKey): string =>
  key === RELATED_MENTION_SECTION_KEY
    ? RELATED_TO_CURRENT_PAGE_LABEL
    : CONTEXTUAL_ENTITY_MENTION_GROUP_LABELS[key];
